import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const CUSTOM_OPTION_VALUE = "custom";
export const CUSTOM_OPTION_LABEL = "Custom";

export const CustomInputContainer = styled(Box)({
  display: "flex",
  alignItems: "flex-end",
  gap: "2px",
  width: "100%",
});
